"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SEARCH_RESULTS_HEADER = void 0;
const SEARCH_RESULTS_HEADER = exports.SEARCH_RESULTS_HEADER = 'search-results-header';
